import { ReactNode } from 'react';
import { SuperTableProps } from '../SuperTable';
import { columnsProps } from '../SuperTable/interface';

/** 合并表格主表配置 */
export interface MergeTableProps extends baseChildrenTableProps, SuperTableProps {
  /** 列配置 */
  columns: MergeTableColumns[]; // 列配置
  /** childrenKey */
  childrenDataKey?: string;
  /** 行唯一标识 */
  mainRowKey?: string | ((record: any) => string);
  
};
/** 合并表格子表配置 */
export interface MergeChildrenTableProps extends baseChildrenTableProps, SuperTableProps {
  
}
export interface baseChildrenTableProps {
  /** 子表行标识 */
  childrenRowKey?: string | ((record: any) => string);
  /** 子表默认展示条数 */
  defaultShowLength?: number | false;
  /** 子表无数据时展示 */
  emptyChildren?: ReactNode;
}
/** 列配置属性 children里放子表的列配置 由于children被占用合并表格将不能使用分组表头 */
export interface MergeTableColumns extends columnsProps {};

/** 子表默认字段名 */
export const DEFAULT_CHILDREN_DATA_KEY: string = 'children';
/** 默认行标识 */
export const DEFAULT_ROW_KEY: string = 'key';
/** 子表默认展示多少行 */
export const DEFAULT_SHOW_LENGTH: number = 3;
/** 子表展开行标识 */
export const CHILDREN_SHOW_OPTION_KEY: string = '_childrenShowOptionKey';
